(ns dre.pages.not-found.views
  (:require
    [dre.i18n.views :refer [tr]]))


(defn view
  []
  [:div.http-404
   [:h1 [tr "Error 404"]]
   [:p [:strong [tr "This page does not exist."]]]])
